// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"a94e6e43","62":"53558bc7","311":"11cefaa8","382":"d53cba6b","416":"7c414253","538":"a5bef68b","545":"363a01e3","566":"84303441","614":"084c75c7","676":"64255bd0","854":"aa67360a"}[chunkId] + ".chunk.js";
};